import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { Immutable } from 'immer';
import { type FC, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { PopoverHint } from 'src/components/BasicComponents';
import type { ManagedTracker } from 'src/store/trackers/trackers_reducers';
import { AddTrackerCommando } from '../AddTrackerCommando/AddTrackerCommando';

interface Props {
  trackersToUse: Immutable<Array<ManagedTracker>> | null;
}

export const SendMessagesToTrackerButton: FC<Props> = ({ trackersToUse }) => {
  const [show, setShow] = useState(false);
  if (trackersToUse == null) return <></>;

  return (
    <>
      <Container onClick={() => setShow(true)}>
        <div>Send messages to trackers</div>
      </Container>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Send a command</Modal.Title>
          <Test>
            <PopoverHint>
              <HelperText>
                Messages configure GPS trackers and can be scheduled for future delivery within a
                defined time frame. The "not-before" time (default: now) sets the earliest sending
                time, while the "not-after" time (default: 5 minutes later) defines the latest.
                Within this time frame, if a TCP socket is open with the target device, RACEMAP
                attempts to send the message. Delivery is confirmed when the device acknowledges
                (ACK) the message. If no ACK is received within 2 minutes, the message is resent -
                up to three attempts. If the message cannot be sent or delivered within the time
                frame, an error occurs.
              </HelperText>
            </PopoverHint>
          </Test>
        </Modal.Header>

        <ModalBody>
          <AddTrackerCommando
            trackerIds={trackersToUse.map((t) => t.id)}
            onCommandsSent={() => setShow(false)}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const HelperText = styled.span`
  color: ${RacemapColors.DarkGray};
  display: block;
`;

const ModalBody = styled(Modal.Body)`
  padding: 30px 15px 0 15px;
`;

const Test = styled.div`
  display: flex;
  align-items: center;
  padding-left: 4px;
  padding-top: 6px;
`;
